import { filterTime } from '@/api/filter';

export const columns = {
  data() {
    const vm = this;
    return {
      // 增员-无门槛
      recruitingColumns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180
        },
        {
          title: '批单号',
          width: '180',
          key: 'billNo',
          align: 'center',
          render(h, params) {
            return <span>{params.row.billNo ? params.row.billNo : '-'}</span>;
          }
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '最新状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执回销日期',
          align: 'center',
          key: 'receiptDate',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 120,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{filterTime(hesitateDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '交费期',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let payDesc = params.row.payDesc;
            return <span>{payDesc ? payDesc : '-'}</span>;
          }
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '实收保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 100
        },
        {
          title: '奖励归属',
          align: 'center',
          key: 'recommend',
          minWidth: 100
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          render(h, params) {
            if (params.row.calFactor == 1) {
              return <span>被推荐人标保</span>;
            } else if (params.row.calFactor == 3) {
              return <span>被推荐人费用</span>;
            } else if (params.row.calFactor == 2) {
              return <span>被推荐人规保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 120,
          render(h, params) {
            return <span>{params.row.actCommission ? params.row.actCommission : '0'}%</span>;
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100
        },
        {
          title: '基础费用归属',
          align: 'center',
          key: 'salesmanName',
          minWidth: 150
        },
        {
          title: '推荐人团队',
          align: 'center',
          key: 'recommendGroup',
          minWidth: 120
        },
        {
          title: '推荐人机构',
          align: 'center',
          key: 'recommendOrg',
          minWidth: 150
        }
      ],

      // 增员-梯度-推荐人
      recruitingUserColumns: [
        {
          title: '被推荐人',
          minWidth: 250,
          align: 'center',
          slot: 'berecommendname_staffNo'
        },
        {
          title: '被推荐人手机号',
          key: 'beRecommendedMobile',
          minWidth: 150,
          align: 'center',
          slot: 'beMobile3'
        },
        {
          title: '保单号',
          key: 'policyNo',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let policyNo = params.row.policyNo;
            return <span>{policyNo ? policyNo : '-'}</span>;
          }
        },
        {
          title: '签约状态',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let recommendType = params.row.recommendType;
            let beRecommendedWorkingState = params.row.beRecommendedWorkingState;
            let beRecommendedIsSus = params.row.beRecommendedIsSus;
            if(recommendType == 1 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>注册</span>;
            } else if (recommendType == 2 && beRecommendedWorkingState != '0' && beRecommendedIsSus != 1) {
              return <span>入职</span>;
            }else if (beRecommendedWorkingState == '0') {
              return <span>离职</span>;
            }else if (beRecommendedIsSus == '1') {
              return <span>停职</span>;
            }
          }
        },
        {
          title: '奖励类型',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let rewardType = params.row.rewardType;
            if (rewardType == 1) {
              return <span>加费</span>;
            } else if (rewardType == 2) {
              return <span>实物</span>;
            } else {
              return <span>现金</span>;
            }
          }
        }
      ],

      // 增员-梯度-机构
      recruitingOrgColumns: [
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '奖励类型',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let rewardType = params.row.rewardType;
            if (rewardType == 1) {
              return <span>加费</span>;
            } else if (rewardType == 2) {
              return <span>实物</span>;
            } else {
              return <span>现金</span>;
            }
          }
        },
        {
          title: '推荐人',
          align: 'center',
          minWidth: 250,
          slot: 'recommendname_staffNo'
        },
        {
          title: '推荐人手机号',
          align: 'center',
          minWidth: 150,
          slot: 'recommendMobile'
        },
        {
          title: '推荐人所属团队',
          align: 'center',
          key: 'recommendGroupName',
          minWidth: 150
        },
        {
          title: '推荐人所属机构',
          align: 'center',
          key: 'recommendOrgName',
          minWidth: 150
        },
        {
          title: '被推荐人',
          minWidth: 250,
          align: 'center',
          slot: 'berecommendname_staffNo'
        },
        {
          title: '被推荐人手机号',
          key: 'beRecommendedMobile',
          minWidth: 150,
          align: 'center',
          slot: 'beMobile3'
        },
        {
          title: '签约状态',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let recommendType = params.row.recommendType;
            if (recommendType == 1) {
              return <span>注册</span>;
            } else if (recommendType == 2) {
              return <span>入职</span>;
            }
          }
        }
      ],

      // 业务员个险
      salesmanInsuranceColumns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '费用归属/业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          slot: 'policyStatus'
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          slot: 'receiptStatus'
        },
        {
          title: '回执回销日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          slot: 'verifyStatus'
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{hesitateDate ? filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let payDesc = params.row.payDesc;
            return <span>{payDesc ? payDesc : '-'}</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 120,
          render(h, params) {
            let actCommission = params.row.actCommission;
            if (vm.reportType == '4-2' && (vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7 || vm.rewardType == 3)) {
              return <span>-</span>;
            } else {
              return <span>{actCommission ? actCommission : '0'}%</span>;
            }
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100,
          render(h, params) {
            let activityIncome = params.row.activityIncome;
            if (vm.reportType == '4-2' && vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7) {
              return <span>-</span>;
            } else {
              return <span>{activityIncome}</span>;
            }
          }
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 100
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ],
      // 业务员团财
      salesmanGroupColumns: [
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left',
          tree: true
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '费用归属/业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 120,
          render(h, params) {
            let actCommission = params.row.actCommission;
            if (vm.reportType == '4-2' && (vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7 || vm.rewardType == 3)) {
              return <span>-</span>;
            } else {
              return <span>{actCommission ? actCommission : '0'}%</span>;
            }
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100,
          render(h, params) {
            let activityIncome = params.row.activityIncome;
            if (vm.reportType == '4-2' && vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7) {
              return <span>-</span>;
            } else {
              return <span>{activityIncome}</span>;
            }
          }
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 130
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ],
      // 机构个险
      orgInsuranceColumns: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          slot: 'policyStatus'
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回执状态',
          minWidth: 100,
          align: 'center',
          slot: 'receiptStatus'
        },
        {
          title: '回执回销日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let receiptDate = params.row.receiptDate;
            return <span>{filterTime(receiptDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回访状态',
          minWidth: 100,
          align: 'center',
          slot: 'verifyStatus'
        },
        {
          title: '回访日期',
          align: 'center',
          key: 'revisitDate',
          minWidth: 130,
          render(h, params) {
            let revisitDate = params.row.revisitDate;
            return <span>{filterTime(revisitDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '犹豫止期',
          align: 'center',
          key: 'hesitateDate',
          minWidth: 130,
          render(h, params) {
            let hesitateDate = params.row.hesitateDate;
            return <span>{hesitateDate ? filterTime(hesitateDate, 'YYYY-MM-DD') : '-'}</span>;
          }
        },
        {
          title: '保障期',
          align: 'center',
          key: 'guaranteeDesc',
          minWidth: 120
        },
        {
          title: '保单年度',
          align: 'center',
          key: 'commissionIndex',
          minWidth: 100,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '交费期次',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            return <span>1</span>;
          }
        },
        {
          title: '投保人',
          align: 'center',
          key: 'holderName',
          minWidth: 100
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 120,
          render(h, params) {
            let actCommission = params.row.actCommission;
            if (vm.reportType == '4-2' && (vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7 || vm.rewardType == 3)) {
              return <span>-</span>;
            } else {
              return <span>{actCommission ? actCommission : '0'}%</span>;
            }
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100,
          render(h, params) {
            let activityIncome = params.row.activityIncome;
            if (vm.reportType == '4-2' && vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7) {
              return <span>-</span>;
            } else {
              return <span>{activityIncome}</span>;
            }
          }
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 100
        }
      ],
      // 机构团财
      orgGroupColumns: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '业务员',
          align: 'center',
          minWidth: 250,
          slot: 'overName_staffNo'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180
        },
        {
          title: '关联活动',
          align: 'center',
          key: 'activityName',
          minWidth: 250
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          slot: 'policyStatus'
        },
        {
          title: '承保日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '起保日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let startTime = params.row.startTime;
            return <span>{filterTime(startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '终保日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let endTime = params.row.endTime;
            return <span>{filterTime(endTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收日期',
          align: 'center',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '标准保费',
          align: 'center',
          key: 'foldFyb',
          minWidth: 120
        },
        {
          title: '业务员基础费用',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 140
        },
        {
          title: '计算因子',
          align: 'center',
          key: 'calFactor',
          minWidth: 130,
          slot: 'calFactor'
        },
        {
          title: '奖励费率',
          align: 'center',
          key: 'actCommission',
          minWidth: 120,
          render(h, params) {
            let actCommission = params.row.actCommission;
            if (vm.reportType == '4-2' && (vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7 || vm.rewardType == 3)) {
              return <span>-</span>;
            } else {
              return <span>{actCommission ? actCommission : '0'}%</span>;
            }
          }
        },
        {
          title: '奖励',
          align: 'center',
          key: 'activityIncome',
          minWidth: 100,
          render(h, params) {
            let activityIncome = params.row.activityIncome;
            if (vm.reportType == '4-2' && vm.conditionalIndicator != 6 && vm.conditionalIndicator != 7) {
              return <span>-</span>;
            } else {
              return <span>{activityIncome}</span>;
            }
          }
        },
        {
          title: '职级',
          align: 'center',
          key: 'rankName',
          minWidth: 100
        }
      ]
    };
  }
};
